// @ts-ignore
/* eslint-disable */
import { apiProxy, apiUrl } from './index';
import { request } from '@umijs/max';

export async function fetchSecurityEventReport(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.securityEventReport}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchSecurityEventOutlets(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.securityEventOutlets}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchManagementEventReport(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.managementEventReport}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchVoiceEventReport(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.voiceEventReport}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchVoiceCategories(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.voiceCategories}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchEventDataHandle(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.eventDataHandle}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchEventDataStatus(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.eventDataStatus}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchEventTypes(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.eventTypes}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchBranchOrgs(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.depts}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchEventOrgs(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.eventOrgs}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchEventRanks({ type = 0, ...params } = {}) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.eventRanks(type)}`, {
    method: 'GET',
    params,
  });
}
